import { Box, IconButton, Stack, Typography } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import React, { useCallback, useEffect, useRef, useState } from "react";

import WaveSurfer from "wavesurfer.js";

const formatTime = (seconds) =>
  [seconds / 60, seconds % 60]
    .map((v) => `0${Math.floor(v)}`.slice(-2))
    .join(":");

function VoiceNotePlayBack({ audioUrl }) {
  const waveformRef = useRef();
  const waveSurferRef = useRef(null);

  const [duration, setduration] = useState(null);
  const [isPlaying, setisPlaying] = useState(false);

  useEffect(() => {
    if (waveformRef.current) {
      const ws = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "rgb(133, 133, 136)",
        progressColor: "rgba(105, 86, 229, 1)",
        url: audioUrl,
        height: "auto",
        cursorColor: "transparent",
      });

      waveSurferRef.current = ws;
    }
  }, [audioUrl]);

  useEffect(() => {
    if (waveSurferRef.current) {
      waveSurferRef.current.on("click", () => {
        waveSurferRef.current.play();
      });
      waveSurferRef.current.on("ready", () => {
        setduration(formatTime(waveSurferRef.current.getDuration()));
      });
      waveSurferRef.current.on("play", () => {
        setisPlaying(true);
      });
      waveSurferRef.current.on("pause", () => {
        setisPlaying(false);
      });
    }
  }, []);

  const onPlayPause = useCallback(() => {
    waveSurferRef.current && waveSurferRef.current.playPause();
  }, []);

  return (
    <Stack
      direction={"row"}
      gap={2}
      width="100%"
      height="44px"
      display="flex"
      alignItems="center"
      justifyContent="space-around"
      sx={{
        background: "rgba(38, 38, 38, 0.06)",
        padding: "8px",
        borderRadius: "8px",
      }}
    >
      {" "}
      <IconButton size="small" onClick={onPlayPause}>
        {isPlaying ? (
          <Box
            sx={{
              width: "36px",
              height: "36px",
              bordeRadius: "11px",
              background: "#E0E0E0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PauseIcon />
          </Box>
        ) : (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_12446_6826)">
              <path
                d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z"
                fill="#E0E0E0"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0003 26.3337C22.6027 26.3337 26.3337 22.6027 26.3337 18.0003C26.3337 13.398 22.6027 9.66699 18.0003 9.66699C13.398 9.66699 9.66699 13.398 9.66699 18.0003C9.66699 22.6027 13.398 26.3337 18.0003 26.3337ZM16.9116 21.2052L20.8451 18.8828C21.4965 18.4982 21.4965 17.5025 20.8451 17.1179L16.9116 14.7955C16.2784 14.4217 15.5003 14.9082 15.5003 15.678V20.3227C15.5003 21.0924 16.2784 21.579 16.9116 21.2052Z"
                fill="#515151"
              />
            </g>
            <defs>
              <clipPath id="clip0_12446_6826">
                <path
                  d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        )}
      </IconButton>
      <Box
        sx={{
          width: {
            xs: "100%",
            sm: "170px",
            lg: "200px",
          },
          height: "50px",
        }}
        ref={waveformRef}
      />
      {
        <Typography fontWeight={700} fontSize={"14px"}>
          {duration}
        </Typography>
      }
    </Stack>
  );
}

export default VoiceNotePlayBack;
